export default "__VITE_ASSET__C1gl8Uvs__"